import { supabase } from "../../supabase/supabaseClient";

export const register = (userData) => async (dispatch) => {
  const name = userData.name;
  const password = userData.password;
  const password1 = userData.password1;
  const isAdmin = userData.isAdmin;
  console.log("===================>", userData);
  try {
    const res1 = await supabase.from("users").select().eq("name", name);
    if (res1.data.length > 0) {
      console.log("User name is already used");
    }

    const { data, error } = await supabase
      .from("users")
      .insert([
        {
          name: name,
          password: password,
          password1: password1,
          isAdmin: isAdmin,
        },
      ])
      .select();
    console.log("data====================>", data);
    if (error) {
      console.log(error.details);
    }
  } catch (error) {
    console.log("Error fetching users", error);
  }
};

export const login = (loginData) => async (dispatch) => {
  const name = loginData.name;
  const password = loginData.password;

  try {
    const res = await supabase
      .from("users")
      .select()
      .eq("name", name)
      .eq("password", password);

    console.log(name, password);
    if (res.data && res.data.length > 0) {
      // Store user data in localStorage
      localStorage.setItem("user", JSON.stringify(res.data));

      dispatch({
        type: "LOGIN_ADMIN",
        payload: res.data,
      });
    }

    if (res.error) {
      console.log(res.error.details);
    }
  } catch (error) {
    console.log("Error fetching users", error);
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("user");
  dispatch({
    type: "LOGOUT",
  });
};
